export default theme => ({

  root: {
    padding: theme.spacing.unit * 3
  },

  actions: {
    marginTop: theme.spacing.unit,
    display: 'flex',
    justifyContent: 'space-between'
  },

  content: {
    padding: theme.spacing.unit
  }

});



// WEBPACK FOOTER //
// ./src/styles/components/LogInForm.js